export const BENEFITS_DURATION = 1500;
export const FEATURES_DURATION = 3500;
